const doc = [({"en":({"js":({"reimbursements":({"create_card":({"extended_form":({"save_button":({"save":"Save"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;